/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { footerAboutMeConfig } from '../../config/footer.config';
export interface IFooterAboutMePluginMethods extends IPluginMethodMap {
  getFooterAboutMeSync(args?: any): any;
}

export class FooterAboutMePlugin implements IAgentPlugin {
  readonly methods: IFooterAboutMePluginMethods;

  constructor() {
    this.methods = {
      getFooterAboutMeSync: this.getFooterAboutMeSync.bind(this),
    };
  }

  getFooterAboutMeSync(args?: any) {
    return {
      footer: footerAboutMeConfig,
    };
  }
}
